import { getData, putData } from '../apiClient';

// get email permissions
export const getEmailPermissions = async () => {
    try {
        const result = await getData("/email-permission/get");
        return {
            data: {
                message: result.message,
                success: true,
                data: result.data
            }
        };
    } catch (error) {
        console.error('Get email permissions API error:', error);
        return {
            data: {
                success: false,
                error: error.message
            }
        };
    }
};

// update email permissions
export const updateEmailPermissions = async ({ data }) => {
    try {
        const result = await putData("/email-permission/update", data);
      
    return {
        data: {
          success: true,
          data: result,
        },
      };
    } catch (error) {
      console.error("Email add API error:", error.status === 400 ? error.error : error.message);
      return {
        data: {
          success: false,
          error: error.status === 400 ? error.error : error.message,
          status: error.status,
        },
      };
    }
};


// get email configuration
export const getEmailConfig = async () => {
    try {
        const result = await getData("/email-config/get");
        return {
            data: {
                message: result.message,
                success: true,
                data: result.data
            }
        };
    } catch (error) {
        console.error('Get email config API error:', error);
        return {
            data: {
                success: false,
                error: error.message
            }
        };
    }
};

// update email configuration
export const updateEmailConfig = async ({ data }) => {
    try {
        const result = await putData("/email-config/update", data);
        return {
            data: {
              success: true,
              data: result,
            },
          };
        } catch (error) {
          console.error("Update Email Config API error:", error);
          return {
            data: {
              success: false,
              error: error.status === 400 ? error.error : error.message,
              status: error.status,
            },
          };
        }
};
